
/**
 * All rights Reserved, Designed By www.feidai.com
 * @Title:  homes.ts
 * @Package :
 * @author:青瞳科技
 * @date:   2022/7/4 14:44
 * @version V1.0
 * @Copyright: 2020 https://www.feisuan.com Inc. All rights reserved.
 * @Belong To: 青瞳科技
 * 注意：本内容仅限于深圳青瞳科技有限公司内部传阅，除非适用法律要求或书面同意，禁止外泄以及用于其他的商业目的
 */
import { assignParams, axiosAPIUrl, Parameter } from './index'

/* 列表数据 */
export class InformationListDTO {
  // 资讯ID
  informationId?: string
  // 资讯标题
  title?: string
  // 封面url
  cover?: string
  // 内容url
  content?: string
  // 状态（-1删除，0保存，1发布，2下架）
  type?: number
  // 类型名称
  typeNam?:string
  // 浏览次数
  visitsNumber?: number
  // 合作方id
  companyId?: string
  // 合作方公司名字
  companyShortName?: string
  // 发布时间
  publishTime?: string
  // 创建时间
  createTime?: string
  // 资讯简介
  informationSynopsis?:string
  // 资讯内容
  articleContent?:string
}

export class InformationList {
  // 公司ID
  companyId?: string
  // 合作方id
  partnerCompanyId?: string
  /* 合作方 */
  // 标题
  title?: string
  // 状态
  type?: number
  // 发布成功开始时间
  publishTimeStart: string
  // 发布成功时间结束
  publishTimeEnd?: string
  // 排序规则(1. visits_number2. publish_time)
  orderBy?: number
  // 排序方式 (1.升序2.降序)
  orderByType?: number

}
/**
 * 普通用户获取资讯列表
 * @param params
 */
export function getInformationList(params: Parameter) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjSystemAudit/IM/getInformationList',
    method: 'get',
    params:{...params, ...assignParams()},
    extraParams:{ showLoading: false }
  })
}
/**
 * 普通用户读取资讯
 * @param params
 */
export function updateInformationVisits(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjSystemAudit/IM/updateInformationVisits',
    method: 'post',
    data: parameter,
    extraParams:{ showLoading: false }
  })
}
/**
 * 合作方获取资讯列表
 * @param params
 */
export function getInformationListByPartner(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjSystemAudit/IM/getInformationListByPartner',
    method: 'get',
    params: parameter,
    extraParams:{ showLoading: false }
  })
}
/**
* 合作方添加资讯
* @param params
*/
export function addInformationByPartner(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjSystemAudit/IM/addInformationByPartner',
    method: 'post',
    data: parameter
  })
}
/**
* 普通用户获取热点资讯列表
* @param params
*/
export function getHotInformationList(parameter: Parameter = {}) {
  return axiosAPIUrl<Ajax.Response<any>>({
    url: '/cykjSystemAudit/IM/addInformationByPartner',
    method: 'get',
    params: parameter,
    extraParams:{ showLoading: false }
  })
}
